"use strict";

(function ($) {
  $.fn.switchValue = function () {
    $(this).on('change', function () {
      var input = $(this).prev();
      input.val($(this).prop('checked'));
    });
  };
})(jQuery);

(function ($) {
  $.fn.checkValue = function () {
    $(this).on('change', function () {
      var target = $(this).data('target');
      checked = $(this).prop('checked');
      $(target).val(checked);
    });
  };
})(jQuery);

$(function () {
  if ($('.js-switch-account').length) {
    $('.js-switch-account').switchValue();
  }

  if ($('.js-check-contact').length) {
    $('.js-check-contact').checkValue();
  }
});